<svg class="sparkline_svg" [attr.width]="width" [attr.height]="height" [attr.stroke-width]="strokeWidth">
    <linearGradient id="sparkline-gradient-{{id}}" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stop-color="currentColor" [attr.stop-opacity]="0.3 * gradientOpacity"/>
        <stop offset="100%" stop-color="currentColor" stop-opacity="0"/>
    </linearGradient>

    <path class="sparkline--line" [attr.d]="sparklineResult?.commands.pathCoords" [attr.fill]="'none'" />
    <path class="sparkline--fill" [attr.d]="sparklineResult?.commands.fillCoords" [attr.fill]="'url(#sparkline-gradient-' + id + ')'" stroke="none" />
    <path class="sparkline--tick-line" [attr.d]="sparklineResult?.commands.tickCoords" [attr.fill]="'none'" />
</svg>
